import { Status as TodoStatus } from '@/entities/todo';
import { findHeader, findResponseType } from '@/_legacy/store/checklist_builder';
import { isEntityTypeOfResponseEnabled } from '@/ui/helpers/featureHelper';
import { ResponsesTypes } from '@/entities/checklist';
import { findItemIsInRepeatedSection } from '@/_legacy/services/inspection';

function mapUserEntityItemsIds(user) {
  return user.entityItems?.map(entityItem => entityItem.id) || [];
}

function isInspectionPending(inspection) {
  return inspection.todo && ![TodoStatus.Done, TodoStatus.InProgress].includes(inspection.todo.status);
}

function isInspectionNew(inspection) {
  return !inspection.inspection_id;
}

export default {
  inspectionEntityItems(user, inspection) {
    const allInspectionEntityItems = Object.keys(inspection.entity_items).map(key => Number(key));
    const userEntityItemsIds = mapUserEntityItemsIds(user);

    if (isInspectionPending(inspection)) {
      if (inspection.todo.entity_item && allInspectionEntityItems.includes(inspection.todo.entity_item)) {
        return [inspection.todo.entity_item];
      }

      return userEntityItemsIds;
    }

    if (userEntityItemsIds.length === 0) {
      return allInspectionEntityItems;
    }

    if (!isInspectionNew(inspection) && !userEntityItemsIds.includes(inspection.entity_item)) {
      return allInspectionEntityItems;
    }

    if (inspection.can_see_all_entity_items) {
      return allInspectionEntityItems;
    }

    return allInspectionEntityItems.filter(entityItem => userEntityItemsIds.includes(entityItem));
  },

  hasNewEntityItemQuestion(inspection) {
    const headerPage = findHeader(inspection.form.items);
    const entityItemQuestion = findResponseType(headerPage, ResponsesTypes.entityItem);

    return isEntityTypeOfResponseEnabled() && entityItemQuestion;
  },

  hasNewEntityItemQuestionInside(item) {
    const entityItemQuestion = findResponseType(item, ResponsesTypes.entityItem);

    return Boolean(isEntityTypeOfResponseEnabled() && entityItemQuestion);
  },

  isInsideRepeatedSection(form, item) {
    const isInRepeatedSection = findItemIsInRepeatedSection(form, item.uuid);

    return isEntityTypeOfResponseEnabled() && isInRepeatedSection;
  },

  wasEntityItemQuestionMigrated(inspection) {
    return isEntityTypeOfResponseEnabled() && inspection.entity_type_of_response_migrated;
  }
};
